var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Platform } from "react-native";
import { call, all, put, takeLatest } from "redux-saga/effects";
import logger from "../../logger";
import * as documentApi from "../../reduxV2/documents/document.api";
import { showAlert } from "../../utils/alert/alert.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import * as contractActionsV2 from "../contract/contract.actions";
import { generateSaga } from "../generators/generator.saga";
import * as rentRegistrationApi from "../rentRegistration/rentRegistration.api";
import { createDocumentPackageStart, createDocumentPackageSucceeded, createDocumentPackageFailed, revokeDocumentPackageStart, revokeDocumentPackageSucceeded, revokeDocumentPackageFailed, remindDocumentPackageSignerStart, remindDocumentPackageSignerSucceeded, remindDocumentPackageSignerFailed, } from "./documentPackage.actions";
import * as documentPackageApi from "./documentPackage.api";
import { GENERATOR_PARAMS } from "./documentPackage.constants";
import { getDocumentCategoryId } from "./documentPackage.utils";
export function createDocumentPackageStartFlow(action) {
    var _a, data, rentRegistration, onSuccess, onFailure, _b, documents, documentPackage, documentsToUpload, documentIds, createdRentRegistrationId, hasCreatedDocumentPackage, presignedUrls, uploadedDocuments, registrationResult, documentPackageResult, unknownError_1, error, unknownCleanupError_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, data = _a.data, rentRegistration = _a.rentRegistration, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b = data.documents, documents = _b === void 0 ? [] : _b, documentPackage = __rest(data, ["documents"]);
                documentsToUpload = documents.filter(function (x) { return typeof x !== "string"; });
                documentIds = documents.filter(function (x) { return typeof x === "string"; });
                hasCreatedDocumentPackage = false;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 10, , 16]);
                return [4 /*yield*/, all(documentsToUpload.map(function (attachment) {
                        var _a, _b, _c, _d;
                        var mobileAttachment = attachment;
                        var file = {
                            name: mobileAttachment.name,
                            path: (_b = (_a = mobileAttachment.file) === null || _a === void 0 ? void 0 : _a.path) !== null && _b !== void 0 ? _b : "",
                            type: (_d = (_c = mobileAttachment.file) === null || _c === void 0 ? void 0 : _c.mime) !== null && _d !== void 0 ? _d : "",
                        };
                        return call(documentApi.uploadDocumentToS3, Platform.OS === "web" ? attachment : file);
                    }))];
            case 2:
                presignedUrls = _c.sent();
                return [4 /*yield*/, all(presignedUrls.map(function (presignedUrl, index) {
                        var metaData = {
                            categoryId: getDocumentCategoryId({
                                documentPackageType: documentPackage.type,
                            }),
                            filename: documentsToUpload[index]
                                .name,
                            isInvisible: true,
                        };
                        return call(documentApi.uploadDocument, presignedUrl, metaData);
                    }))];
            case 3:
                uploadedDocuments = _c.sent();
                if (!rentRegistration) return [3 /*break*/, 5];
                return [4 /*yield*/, call(rentRegistrationApi.create, { data: rentRegistration })];
            case 4:
                registrationResult = _c.sent();
                createdRentRegistrationId = registrationResult.data.data.id;
                _c.label = 5;
            case 5: return [4 /*yield*/, call(documentPackageApi.createDocumentPackage, __assign(__assign(__assign({}, documentPackage), (createdRentRegistrationId != null
                    ? { rentRegistrationId: createdRentRegistrationId }
                    : {})), { documentsUploadedIds: __spreadArray(__spreadArray([], documentIds, true), uploadedDocuments.map(function (uploadedDocument) { return uploadedDocument === null || uploadedDocument === void 0 ? void 0 : uploadedDocument.id; }), true) }))];
            case 6:
                documentPackageResult = _c.sent();
                hasCreatedDocumentPackage = true;
                if (!rentRegistration) return [3 /*break*/, 8];
                // The contract card reads the registration through its denormalized
                // `rentRegistrationId`, so refresh it or the card keeps saying
                // "not registered" while the signing runs.
                return [4 /*yield*/, put(contractActionsV2.getDetailStart.getAction({
                        id: rentRegistration.contractId,
                    }))];
            case 7:
                // The contract card reads the registration through its denormalized
                // `rentRegistrationId`, so refresh it or the card keeps saying
                // "not registered" while the signing runs.
                _c.sent();
                _c.label = 8;
            case 8: return [4 /*yield*/, put(createDocumentPackageSucceeded.getAction({ data: documentPackageResult }))];
            case 9:
                _c.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(documentPackageResult);
                return [3 /*break*/, 16];
            case 10:
                unknownError_1 = _c.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                if (hasCreatedDocumentPackage) {
                    // The package exists and already links to the registration, so whatever
                    // threw came after the work succeeded - today only a caller's onSuccess.
                    // Compensating would strand that link, and reporting a failure would put
                    // an error alert and onFailure on a create that actually went through.
                    return [2 /*return*/];
                }
                if (!(createdRentRegistrationId != null)) return [3 /*break*/, 14];
                _c.label = 11;
            case 11:
                _c.trys.push([11, 13, , 14]);
                return [4 /*yield*/, call(rentRegistrationApi.remove, {
                        id: createdRentRegistrationId,
                    })];
            case 12:
                _c.sent();
                return [3 /*break*/, 14];
            case 13:
                unknownCleanupError_1 = _c.sent();
                logger.logError({ error: unknownCleanupError_1 });
                return [3 /*break*/, 14];
            case 14: return [4 /*yield*/, put(createDocumentPackageFailed.getAction({
                    error: error,
                }))];
            case 15:
                _c.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 16];
            case 16: return [2 /*return*/];
        }
    });
}
function revokeDocumentPackageStartFlow(action) {
    var _a, documentPackageId, onSuccess, unknownError_2, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, documentPackageId = _a.documentPackageId, onSuccess = _a.onSuccess;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(documentPackageApi.revokeDocumentPackage, documentPackageId)];
            case 2:
                _b.sent();
                return [4 /*yield*/, put(revokeDocumentPackageSucceeded.getAction({ documentPackageId: documentPackageId }))];
            case 3:
                _b.sent();
                showAlert({
                    type: "success",
                    message: getLocalizedText("document_package.revoke.success"),
                });
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(documentPackageId);
                return [3 /*break*/, 6];
            case 4:
                unknownError_2 = _b.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                return [4 /*yield*/, put(revokeDocumentPackageFailed.getAction({
                        documentPackageId: documentPackageId,
                        error: error,
                    }))];
            case 5:
                _b.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function remindDocumentPackageSignerStartFlow(action) {
    var _a, documentPackageId, signerAccountId, onSuccess, unknownError_3, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, documentPackageId = _a.documentPackageId, signerAccountId = _a.signerAccountId, onSuccess = _a.onSuccess;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(documentPackageApi.remindDocumentPackageSigner, documentPackageId, signerAccountId)];
            case 2:
                _b.sent();
                return [4 /*yield*/, put(remindDocumentPackageSignerSucceeded.getAction({
                        documentPackageId: documentPackageId,
                        signerAccountId: signerAccountId,
                    }))];
            case 3:
                _b.sent();
                showAlert({
                    type: "success",
                    message: getLocalizedText("document_package.remind_signer.alert.success"),
                });
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(documentPackageId, signerAccountId);
                return [3 /*break*/, 6];
            case 4:
                unknownError_3 = _b.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                return [4 /*yield*/, put(remindDocumentPackageSignerFailed.getAction({
                        documentPackageId: documentPackageId,
                        signerAccountId: signerAccountId,
                        error: error,
                    }))];
            case 5:
                _b.sent();
                showAlert({
                    type: "error",
                    error: error,
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
export function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(createDocumentPackageStart.type, createDocumentPackageStartFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(revokeDocumentPackageStart.type, revokeDocumentPackageStartFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(remindDocumentPackageSignerStart.type, remindDocumentPackageSignerStartFlow)];
            case 3:
                _a.sent();
                return [4 /*yield*/, generateSaga(GENERATOR_PARAMS)];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
